export default "__VITE_ASSET___QS92LFO__"